export const RECORD_ACHIEVEMENT_TABLE_MAP = {
  '{achievementTableTarget}': 'Target',
  '{achievementTableUnitOfValue}': 'Unit of value',
  '{achievementTableWeighting}': 'Weighting',
  '{achievementTableTargetValues}': 'Target values',
  '{achievementTableTargetAchievement}': 'Target achievement',
  '{achievementFirstTargetPercent}': '0%',
  '{achievementSecondTargetPercent}': '100%',
  '{achievementThirdTargetPercent}': '200%',
  '{achievementTableActualValue}': 'Actual value',
  '{achievementPayoutTargetIncentiveAmountIn}': 'Target incentive amount in ',
  '{achievementPayoutProrated}': ' (prorated)',
  '{achievementPayoutPayoutAmountIn}': 'Payout amount in ',
  '{achievementFactorTitleIndividualMultiplier}': 'Individual Multiplier',
  '{achievementFactorTitle}': 'Siemens Factor',
  '{achievementFactorTotalAchievementInPercent}': 'Target Achievement in %',
  '{achievementFactorCalculationDescription}': 'Achievement x Multiplier',
  '{achievementFactorTargetIncentiveAmountIn}': 'Target incentive amount in ',
  '{achievementIppUnitTargetAchievementInPercent}': 'Unit target achievement in %',
  '{achievementIppIndividual}': 'individual',
  '{achievementIppDecisionDescription}': 'Decision in PMP-EFA Round Table (Individual Performance Percentage - IPP)',
  '{achievementIppOverallTargetAchievementInPercent}': 'Overall target achievement in %',
  '{achievementFactorIndividualMultiplierBetween}': 'between 0.8 - 1.2',
  '{achievementPayoutResultPeriod}': 'Results for the review period'
};
